<script>
import { onMount, createEventDispatcher, afterUpdate, beforeUpdate } from 'svelte';
import { formatDatetimeForGCApi } from '../../helpers/datetime.js';

const dispatch = createEventDispatcher();

export let column;
let currCol;
export let row;
let currRow;
export let z;
export let time;
export let style;
export let layer;
export let width;
export let height;

let frame;
let loader;
let layerimg;

let src;

beforeUpdate(async () => {
  if (column !== currCol && row !== currRow) {
    src = getSrc();
    currCol = column;
    currRow = row;
  }
});

function tile2long(x, z) {
  return (x/Math.pow(2,z)*360-180);
}

function tile2lat(y, z) {
  var n = Math.PI-2*Math.PI*y/Math.pow(2,z);
  return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))));
}

function getSrc() {
  const x1 = tile2long(column, z);
  const x2 = tile2long(column+2, z); // tiles are 4x4
  const y1 = tile2lat(row, z);
  const y2 = tile2lat(row+2, z); // tiles are 4x4
  const bbox = `${y2},${x1},${y1},${x2}`;
  let url = `https://geo.weather.gc.ca/geomet?lang=E&service=WMS&request=GetMap&bbox=${bbox}&version=1.3.0&crs=EPSG:4326&layers=${layer}&style=${style}&width=${width}&height=${height}&format=image/png`

  if (time) {
    url = url + "&time=" + formatDatetimeForGCApi(time);
  }

  return url;
}

afterUpdate(async () => {
    loader.classList.add("loaded");
    layerimg.classList.remove("visible");
});

function imageLoaded() {
  console.log(src + " loaded")
  loader.classList.remove("loaded");
  layerimg.classList.add("visible");
}
</script>

<style>
.frame {
    position: absolute;
    z-index: 1;
}
img {
  opacity: 0;
  pointer-events: none;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #db3490;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
  position: absolute;
  left: 40%;
  top: 20%;
  opacity: 0;
}

.loaded {
  opacity: 1;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.visible {
    opacity: 1;
    animation: fadeIn ease 1s;
    -webkit-animation: fadeIn ease 1s;
    -moz-animation: fadeIn ease 1s;
    -o-animation: fadeIn ease 1s;
    -ms-animation: fadeIn ease 1s;
}
</style>
<div class="frame" data-column="{column}" data-row="{row}"
    bind:this={frame}
    style="width: {width}px; height: {height}px; transform: translate3d({(column*256)}px, {(row*256)}px, 0px) scale({1});">
      <div class="loader loaded" bind:this={loader}></div>
      {#if src}
        <img src={src} 
              on:load={imageLoaded}
              bind:this={layerimg}
              alt="Layer" 
              draggable="false" 
              class="noselect visible" />
      {/if}
</div>